// @flow strict

/* Intro Routes */
export const INTRO_STATE_ROUTE = '/intro/state';
export const INTRO_COVERAGE_YEAR_ROUTE = '/intro/coverage';
export const INTRO_DISCLAIMER_ROUTE = '/intro/disclaimer';
export const SUBSIDY_CONFIRM_ROUTE = '/background/subsidy-confirmation'; // this question move to the front. Rename later

/* Household Contact (Primary Info) Routes */
export const PRIMARY_DETAILS_ROUTE = '/background/primary';
export const PRIMARY_CONTACT_ROUTE = '/background/contact';
export const PRIMARY_ADDRESS_ROUTE = '/background/address';
export const PRIMARY_OUT_OF_STATE_ROUTE = '/background/out-of-state';
export const BACKGROUND_FOLLOWUP_ROUTE = '/background/primary-followup'; // if primary has some missing info, we redirect to this for follow-up

/* ID Verify Routes */
export const ID_VERIFY_START_ROUTE = '/id-verify/start';
export const ID_VERIFY_QUESTIONS_ROUTE = 'id-verify/questions';
export const ID_VERIFY_VERIFIED = '/id-verify/verified';
export const ID_UNVERIFIED_ROUTE = '/id-verify/unverified';
export const ID_VERIFY_FARS_ROUTE = '/id-verify/fars';
export const ID_VERIFY_QUESTION = '/id-verify/questions';
export const FFM_REDIRECT_ROUTE = '/background/ffm-redirect';

/* Member Routes */
export const MEMBER_FOLLOWUP_ROUTE = '/household/followup';

// Household Composition Routes
export const COMPOSITION_COVERAGE_ROUTE = '/household/composition/coverage';
export const COMPOSITION_APPLICANT_ROUTE = '/household/composition/applicants';
export const COMPOSITION_APPLICANT_EDIT_ROUTE = '/household/composition/applicants/:applicantId';
export const COMPOSITION_APPLICANT_ADDRESS_ROUTE =
  '/household/composition/applicants/:applicantId/address';
export const COMPOSITION_APPLICANT_REMOVE_ROUTE =
  '/household/composition/applicants/:applicantId/remove';
export const COMPOSITION_RELATIONSHIP_ROUTE = '/household/composition/relationship';
export const COMPOSITION_SUMMARY_ROUTE = '/household/composition/summary';

// Tax Household Routes
export const TAX_INTRO_ROUTE = '/household/tax/intro';
export const TAX_COMPOSITION_ROUTE = '/household/tax/composition';
export const TAX_DEPENDENT_ROUTE = '/household/tax/dependents';
export const TAX_DEPENDENT_EDIT_ROUTE = '/household/tax/dependent/:dependentId';
export const TAX_DEPENDENT_ADDRESS_ROUTE = '/household/tax/dependent/:dependentId/address';
export const TAX_CLAIMED_AS_DEPENDENT_ROUTE = 'household/tax/additional';
export const TAX_SUMMARY = 'household/tax/summary';

export const CARETAKER_ROUTE = '/household/caretaker';
export const CARETAKER_DEPENDENT_ROUTE = '/household/caretaker/:dependentId';

export const CITIZENSHIP_ROUTE = '/household/citizenship';
export const CITIZENSHIP_VERIFY_ROUTE = '/household/citizenship/verify';
export const NATURALIZATION_ROUTE = '/household/naturalization';
export const NATURALIZATION_VERIFY_ROUTE = '/household/naturalization/verify';
export const LAWFUL_PRESENCE_ROUTE = '/household/immigration/lawful-presence';
export const LAWFUL_PRESENCE_DOCUMENTS_ROUTE = '/household/immigration/lawful-presence-documents';
export const LAWFUL_PRESENCE_VERIFY_ROUTE = '/household/immigration/lawful-presence/verify';
export const LAWFUL_PRESENCE_ADDITIONAL_DOCUMENTS_ROUTE =
  '/household/immigration/lawful-presence-additional-documents';
export const SEVIS_ROUTE = '/household/immigration/sevis';
export const GRANT_DATE_ROUTE = '/household/immigration/grant-date';
export const RESIDENCE_ROUTE = '/household/immigration/residence';
export const VETERAN_ROUTE = '/household/immigration/veteran';
export const PREGNANCY_ROUTE = '/household/pregnancy';
export const FOSTER_CARE_ROUTE = '/household/foster-care';
export const FULL_TIME_STUDENT_ROUTE = '/household/full-time-student';
export const INCARCERATION_ROUTE = '/household/incarceration';
// CHANGED** was /additional/american-indian-alaskan-native
export const ADDITIONAL_AMERICAN_INDIAN_ALASKAN_NATIVE_ROUTE =
  '/household/american-indian-alaskan-native';

/* Income Route */
export const INCOME_START_ROUTE = '/income';
export const INCOME_ENTRY_ROUTE = '/income/entry';
export const INCOME_ARP_ROUTE = '/income/arp';
export const INCOME_CONFIRMATION_ROUTE = '/income/confirmation';

/* Additional Routes */
export const ADDITIONAL_START_ROUTE = '/additional';
export const ADDITIONAL_OPTIONAL_ROUTE = '/additional/optional';
export const ADDITIONAL_COVERAGE_ROUTE = '/additional/coverage';
export const ADDITIONAL_APTC_HRA_ROUTE = '/additional/aptc-hra';
export const ADDITIONAL_APTC_ESC_ROUTE = '/additional/aptc-esc';
export const IMMIGRATION_CHIP_DENIAL_ROUTE = '/additional/immigration';
export const MEDICAID_COVERAGE_END_ROUTE = '/additional/medicaid/coverage-end';
export const MEDICAID_PAYMENT_HELP_ROUTE = '/additional/medicaid/payment-help';
export const MEDICAID_CHILDREN_ROUTE = '/additional/medicaid/children';
export const CHIP_STATE_COVERAGE_ROUTE = '/additional/medicaid/state-coverage';
export const HELP_APPLYING_ROUTE = '/additional/help-applying';
export const HEALTH_COVERAGE_ROUTE = '/additional/health-coverage';
export const QHP_APTC_SEP_ROUTE = '/additional/qhp-aptc-sep';
export const LIFE_CHANGES_ROUTE = '/additional/life-changes';
export const HRA_QHP_INTRO_ROUTE = '/additional/hra-intro';
export const APTC_AIAN_PAGE = '/additional/aptc-aian';

/* Other Routes */
export const APP_SUMMARY_ROUTE = '/summary';
export const ATTESTATION_ROUTE = '/additional/attestation';
export const ELIGIBILITY_RESULTS_ROUTE = '/eligibility/results';
export const ELIGIBILITY_APPEALS_ROUTE = '/eligibility/appeals';
export const COMPLETE_ROUTE = '/complete';
export const ELIGIBILITY_SIGN_ROUTE = '/eligibility/sign';
export const ENROLLMENT_ROUTE = '/enrollment';
export const PLAN_PAGE_ROUTE = '/plan';

// Enrollment Group Routes
export const ENROLLMENT_GROUP_EDIT_GROUPS_ROUTE = '/enrollment-group/edit';
export const ENROLLMENT_GROUP_CONFIRM_GROUPS_ROUTE = '/enrollment-group/confirm';
export const ENROLLMENT_GROUP_VIEW_ALL_PLANS_ROUTE = '/enrollment-group/:groupId/select/all/plans';
export const ENROLLMENT_GROUP_COMPARE_PLANS_ROUTE =
  '/enrollment-group/:groupId/select/plans/all/compare';
export const ENROLLMENT_GROUP_COMPARE_PLANS_DETAIL_ROUTE =
  '/enrollment-group/:groupId/select/plans/all/compare/:firstId/:secondId';
export const ENROLLMENT_GROUP_PLAN_DETAIL_ROUTE =
  '/enrollment-group/:groupId/select/plans/detail/:planId';
export const ENROLLMENT_GROUP_CONFIRM_PLANS_ROUTE = '/enrollment-group/:groupId/plan/confirm';

// DEPRECATED ROUTES - remove later
export const BACKGROUND_HOUSEHOLD_ROUTE = '/background/household';
export const HOUSEHOLD_COVERAGE_ROUTE = '/background/household/coverage';
export const SCREENER_START_ROUTE = '/background/part1';
export const SCREENER_COVERAGE_ROUTE = '/background/part2';
export const SCREENER_DEPENDENT_ROUTE = '/background/part3';

export const LOGIN_ROUTE = '/account/login';

// Voter Registration Routes
export const VOTER_REGISTRATION_QUESTION = '/voter-registration/question';
export const VOTER_REGISTRATION_INFORMATION = '/voter-registration/information';
